<template>
  <div class="tags-input form-control">
    <VueTagsInput
      v-model="search"
      :tags=tags
      :autocomplete-items="options"
      :autocomplete-always-open="!!(statictags.length) && focused"
      :add-on-key="[13, 188]"
      :save-on-key="[13, 188]"
      @tags-changed="newTags => tags = newTags"
      @focus="focus(true)"
      @blur="focus(false)"
    />
    <Icon name="refresh" v-if="loading" class="loading" />
  </div>
</template>

<script>
  import Recordset from '@/providers/api/Recordset'
  import {abstractField} from "vue-form-generator";
  import VueTagsInput from '@johmun/vue-tags-input';
  import _ from 'lodash'

  export default {
    name: 'field-tags',
    mixins: [abstractField],
    components: {
      VueTagsInput,
    },
    data () {
      var tags = [];
      if (typeof this.value === 'object') {
        if (this.value instanceof Recordset) {
          tags = this.value.map(t => ({
            text: t.name,
          }));
        } else if (Array.isArray(this.value)) {
          tags = _.clone(this.value).map(text => ({
            text
          }));
        }
      }
      return {
        loading: false,
        focused: false,
        focustimeout: null,
        search: '',
        tags,
        cancel: {},
        apitags: [],
        statictags: this.schema.static || [],
        debounced: _.debounce(() => {
          this.getTags();
        }, 300),
      }
    },
    computed: {
      options () {
        var filter = text => {
          if (this.search) {
            var searchWords = this.search.split(' ').map(w => w.trim().toLowerCase()).filter(w => w);
            var textWords = text.split(' ').map(w => w.trim().toLowerCase()).filter(w => w);
            loop_words: for (let searchWord of searchWords) {
              for (let textWord of textWords) {
                if (textWord.indexOf(searchWord) !== -1) {
                  continue loop_words;
                }
              }
              return false;
            }
          }
          return true;
        };
        return [].concat(
          this.statictags
            .filter(filter)
            .map(text => ({
                classes: 'static',
                text
              })
            )
          ,
          this.apitags
            .filter(filter)
            .map(text => ({
                classes: 'api',
                text
              })
            )
          ,
        );
      },
    },
    methods: {
      focus (focused) {
        if (focused) {
          if (this.focustimeout) {
            clearTimeout(this.focustimeout);
            this.focustimeout = null;
          }
          this.focused = true;
        } else {
          this.focustimeout = setTimeout(() => this.focused = false, 300);
        }
      },
      doCancel () {
        this.loading = false;
        if (this.cancel.function) {
          this.cancel.function();
          this.cancel = {};
        }
      },
      getTags () {
        this.doCancel();
        if (this.search) {
          this.loading = true;
          this.api.get('tags?range=0,10&q=' + encodeURIComponent(this.search), this.cancel)
            .then(t => {
              this.apitags = t
                .mapped('name')
                .filter(n => this.statictags.indexOf(n) === -1)
              ;
            })
            .finally(() =>
              this.loading = false
            )
          ;
        } else {
          this.apiTags = [];
        }
      },
    },
    watch: {
      value (v, o) {
        if (v && o && v.length !== o.length) {
          this.tags = this.value.map(t => ({
            text: typeof t === 'object' ? t.name : t
          }));
        }
      },
      tags () {
        this.$el.querySelector('input.new-tag-input').focus();
        this.value = this.tags.map(t => t.text);
      },
      search () {
        this.debounced();
      },
    },
    mounted () {
      this.getTags();
      //set value immediately
      this.value = this.tags.map(t => t.text);
    },
    beforeDestroy () {this.doCancel();},
  }
</script>

<style lang="scss">
  $color: #c2c2c2;
  div.tags-input.form-control {
    position: relative;
    padding: 0;
    .vue-tags-input {
      width: 100%;
      max-width: 100%;
      .input {
        border: none;
        padding-top: 7px;
        padding-bottom: 7px;
        .tags {
          align-items: center;
        }
      }
      .autocomplete {
        border: none;
        @include panel-shadow();
        top: calc(100% + 2px);
        li.item.static {
          font-weight: 700;
        }
        li.item.selected-item {
          background-color: $color;
        }
      }
    }
    .loading {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      top: 12px;
      right: 11px;
      animation: spin 1000ms linear infinite;
    }
    .tag {
      background-color: $color;
      padding: 0 10px;
      border-radius: 12px;
      line-height: 26px;
      font-size: 16px;
    }
  }
  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/Tags.vue